import axios from 'axios'

// Add request interceptor to automatically include X-Academy-Id header
// This will be added to the global axios instance
axios.interceptors.request.use(
  config => {
    // Directly read from localStorage to avoid circular dependency
    const storedAcademy = localStorage.getItem('selectedAcademy')
    if (storedAcademy) {
      try {
        const academy = JSON.parse(storedAcademy)
        if (academy && academy.id) {
          config.headers = {
            ...config.headers,
            'X-Academy-Id': academy.id,
          }
        }
      } catch (e) {
        // Invalid JSON in localStorage, ignore
      }
    }

    return config
  },
  error => Promise.reject(error),
)

export default axios
